import { render, staticRenderFns } from "./CustomerDynamics.vue?vue&type=template&id=91eea080&scoped=true&"
import script from "./CustomerDynamics.vue?vue&type=script&lang=js&"
export * from "./CustomerDynamics.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDynamics.vue?vue&type=style&index=0&id=91eea080&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91eea080",
  null
  
)

export default component.exports